module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-roman.var.woff2?57fa490cecd74c7c8cab3d5e4b895e64";